<template>
  <div>
    <div class="carousel">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item>Office Space</a-breadcrumb-item>
        <a-breadcrumb-item>Texas</a-breadcrumb-item>
        <a-breadcrumb-item>Dallas</a-breadcrumb-item>
        <a-breadcrumb-item>11615 Forest Central Dr, Dallas, TX 75243</a-breadcrumb-item>
      </a-breadcrumb>
      <a-carousel arrows autoplay variableWidth>
        <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;zIndex: 100">
          <a-icon class="icon" type="left-circle" />
        </div>
        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px;zIndex: 100">
          <a-icon class="icon" type="right-circle" />
        </div>
        <div v-for="item, index in 11" :key="index">
          <img :src="img[item + 1]" />
        </div>
      </a-carousel>
    </div>
    <a-layout>
      <a-layout-content>
        <a-row type="flex" justify="center" align="top">
          <a-col :xs="24" :sm="24" :md="24" :lg="23" :xl="23">
            <section class="content">
              <h2>HIGHLIGHTS</h2>
              <a-row>
                <a-col :span="12">
                  <ul class="list">
                    <li>Flexible Lease Terms and Competitive Rents</li>
                    <li>On-site Management</li>
                    <li>Controlled Access</li>
                  </ul>
                </a-col>
                <a-col :span="12">
                  <ul class="list">
                    <li>Forest Lane DART station nearby</li>
                    <li>Strong residential and business neighborhood</li>
                    <li>Easily accessible to I-635, US 75, and North Dallas Tollway</li>
                  </ul>
                </a-col>
              </a-row>
            </section>
            <section class="content">
              <h2>ALL AVAILABLE SPACES({{dataCount}})</h2>
              <a-table :columns="columns" :data-source="data" class="components-table-demo-nested" :pagination="false">
                <div class="expend" slot="expandedRowRender" slot-scope="record" style="margin: 0">
                  <a-row>
                    <a-col :span="24">
                      <img class="expendImg" alt="" :src="roomImg(record.img)" />
                    </a-col>
                    <a-col :span="24">
                      <div style="display:flex;">
                        <ul>
                          <li v-for="(item1, index1) in record.description1" :key="index1">{{item1}}</li>
                        </ul>
                        <ul>
                          <li v-for="(item2, index2) in record.description2" :key="index2">{{item2}}</li>
                        </ul>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </a-table>
            </section>
            <section class="content">
              <h2>PROPERTY OVERVIEW</h2>
              <a-row>
                <a-col :span="12">
                  <p>51,450 sf, 3 story, full service office building. On site management and security, 24 hour HVAC, covered parking available. Spaces available for immediate occupancy. Great location. Competitive rents.<br> Great Location near SEC of Forest Lane and Central</p>
                </a-col>
                <a-col :span="12">
                  <p>Expressway ( US Hwy 75). Forest Lane DART Station nearby. Easy access to I-635, US Hwy 75 and North Dallas Tollway. Numerous restaurants, retail, service, and institutions in the area including US Post office, FedEX/Kinkos, Home Depot, Medical City.</p>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-row>
                    <a-col :span="12">
                      <ul class="list">
                        <li>24 Hour Access</li>
                        <li>Atrium</li>
                        <li>Bus Line</li>
                      </ul>
                    </a-col>
                    <a-col :span="12">
                      <ul class="list">
                        <li>Controlled Access</li>
                        <li>Commuter Rail</li>
                        <li>Metro/Subway</li>
                      </ul>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="12">
                  <a-row>
                    <a-col :span="12">
                      <ul class="list">
                        <li>Property Manager on Site</li>
                        <li>Security System</li>
                        <li>Signage</li>
                      </ul>
                    </a-col>
                    <a-col :span="12">
                      <ul class="list">
                        <li>Central Heating</li>
                        <li>Fully Carpeted</li>
                        <li>Air Conditioning</li>
                      </ul>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </section>
            <section class="content">
              <h2>PROPERTY FACTS</h2>
              <a-row>
                <a-col :span="8">
                  <dl>
                    <dt>Building Type</dt>
                    <dd>Office</dd>
                  </dl>
                  <dl>
                    <dt>Year Built</dt>
                    <dd>1980</dd>
                  </dl>
                  <dl>
                    <dt>Parking</dt>
                    <dd>Surface Parking<br>Covered Parking at $35/month</dd>
                  </dl>
                </a-col>
                <a-col :span="8">
                  <dl>
                    <dt>Building Height</dt>
                    <dd>3 Stories</dd>
                  </dl>
                  <dl>
                    <dt>Building Size</dt>
                    <dd>51,450 SF</dd>
                  </dl>
                </a-col>
                <a-col :span="8">
                  <dl>
                    <dt>Building Class</dt>
                    <dd>B</dd>
                  </dl>
                  <dl>
                    <dt>Typical Floor Size</dt>
                    <dd>17,150 SF</dd>
                  </dl>
                </a-col>
              </a-row>
            </section>
            <section class="map">
              <h2>MAP</h2>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3349.629817078943!2d-96.76990698452951!3d32.907954384604125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c201265cd1fd5%3A0x99c8a355334a2183!2s11615%20Forest%20Central%20Dr%2C%20Dallas%2C%20TX%2075243!5e0!3m2!1sen!2sus!4v1641111557865!5m2!1sen!2sus" width="100%" height="450" style="border:0;display: block;" allowfullscreen="" loading="lazy"></iframe>
            </section>
            <section class="content transit">
              <h2>TRANSPORTATION</h2>
              <h5><mdicon class="cIcon" name="train-variant" />TRANSIT/SUBWAY</h5>
              <a-row class="line">
                <a-col :span="16">
                  Forest Lane Transit Stop
                  <i><img :src='img.dart' alt="dart"/></i>
                  <i><img :src='img.redline' alt="redline"/></i>
                  <i><img :src='img.orangeline' alt="orangeline"/></i>
                </a-col>
                <a-col :span="4" class="toRight">
                  9 min walk
                </a-col>
                <a-col :span="4" class="toRight">
                  0.4 mi
                </a-col>
              </a-row>
              <h5 class="mt30"><mdicon class="cIcon" name="airplane" />AIRPORT</h5>
              <a-row class="line">
                <a-col :span="16">
                  Dallas Love Field Airport
                </a-col>
                <a-col :span="4" class="toRight">
                  19 min drive
                </a-col>
                <a-col :span="4" class="toRight">
                  9.9 mi
                </a-col>
              </a-row>
              <a-row class="line">
                <a-col :span="16">
                  Dallas/Fort Worth International Airport
                </a-col>
                <a-col :span="4" class="toRight">
                  31 min drive
                </a-col>
                <a-col :span="4" class="toRight">
                  22.6 mi
                </a-col>
              </a-row>
            </section>
          </a-col>
        </a-row>
      </a-layout-content>
      <a-layout-sider>
        <a-affix :offset-top="140">
          <a-card class="card">
            <dl class="manager">
              <dt>
                <img :src='img.manager' alt="One Forest Centre">
              </dt>
              <dd>
                <h4>Laura</h4>
                <h4>Cao</h4>
              </dd>
            </dl>
            <h3><mdicon class="rIcon" name="phone" />972-922-4582</h3>
            <h2>Cloister Properties LLC</h2>
            <p>11615 Forest Central Dr, Suite 108,<br>Dallas, TX 75243</p>
          </a-card>
        </a-affix>
      </a-layout-sider>
    </a-layout>
  </div>
</template>

<script>
import localData from '@/assets/data/20220101.json'
export default {
  name: 'Home',
  data() {
    return {
      img: {
        manager: require('@/assets/img/manager.jpg'),
        dart: require('@/assets/img/dart.png'),
        redline: require('@/assets/img/redline.png'),
        orangeline: require('@/assets/img/orangeline.png'),
        1: require('@/assets/img/1.jpg'),
        2: require('@/assets/img/2.jpg'),
        3: require('@/assets/img/3.jpg'),
        4: require('@/assets/img/4.jpg'),
        5: require('@/assets/img/5.jpg'),
        6: require('@/assets/img/6.jpg'),
        7: require('@/assets/img/7.jpg'),
        8: require('@/assets/img/8.jpg'),
        9: require('@/assets/img/9.jpg'),
        10: require('@/assets/img/10.jpg'),
        11: require('@/assets/img/11.jpg'),
        12: require('@/assets/img/12.jpg')
      },
      columns: [
        { title: 'SPACE', dataIndex: 'space', key: 'space' },
        { title: 'SIZE', dataIndex: 'size', key: 'size' },
        { title: 'TERM', dataIndex: 'term', key: 'term' },
        { title: 'RATE', dataIndex: 'rate', key: 'rate' },
        { title: 'SPACE USE', dataIndex: 'spaceuse', key: 'spaceuse' },
        { title: 'CONDITION', dataIndex: 'condition', key: 'condition' },
        { title: 'AVAILABLE', dataIndex: 'available', key: 'available' },
      ],
      data: []
    }
  },
  computed: {
    dataCount () {
      return this.data.length
    }
  },
  methods: {
    // Resolve a room image from src/assets/img by its filename.
    // Keeps the image path in sync with the bundled assets instead of
    // pointing at a nonexistent /pic/ folder.
    roomImg: function (name) {
      try {
        return require('@/assets/img/' + name)
      } catch (e) {
        return ''
      }
    },
    run: function () {
      let that = this
      this.$axios.get('https://oneforestcentre.com/data/20220101.json').then((data) => {
        that.processData(data.data)
      }).catch(error => {
        // API unavailable -> fall back to bundled data so the listing still shows
        that.processData(localData)
      })
    },
    processData: function (data) {
      this.data = []
      let len = data.length
      for (let i = 0; i < len; i++) {
        this.data.push({
          key: i,
          space: data[i].space,
          size: data[i].size,
          term: data[i].term,
          rate: data[i].rate,
          spaceuse: data[i].spaceuse,
          condition: data[i].condition,
          available: data[i].available,
          description1: data[i].description1,
          description2: data[i].description2,
          img: data[i].img
        })
      }
    }
  },
  mounted() {
    this.run()
  },
}
</script>
